import {
  QueryProps,
  useGetMediaListFromQuery,
  useMediaListByIdSelector,
} from "@nf/common";

export const useInfiniteScrollData = (
  mediaListId: string,
  queryParams: QueryProps
) => {
  const mediaList = useMediaListByIdSelector(mediaListId);

  const { getList, getMore } = useGetMediaListFromQuery(
    mediaListId,
    queryParams,
    mediaList.Filter,
    mediaList.PageSize
  );

  return { getList, getMore, mediaList };
};
